import React from 'react'

export default ({title}) => <h2 className="chat-title">{title}</h2>



// WEBPACK FOOTER //
// ./src/components/chat_window/chat_title.js